<script lang="ts">
	import * as api from '$lib/shared/apis';
	import { isAuthenticated, user } from '$lib/stores/auth';
	import { createEventDispatcher } from 'svelte';

	let error;
	let success;
	let email = '';
	let password = '';
	let resent = false;
	let forgotPasswordFormIsVisible = false;
	const dispatch = createEventDispatcher();

	const toggleForgotPasswordForm = () => {
		forgotPasswordFormIsVisible = !forgotPasswordFormIsVisible;
	};
	const login = async () => {
		error = '';
		const { response, json } = await api.post({
			query: /* GraphQL */ `
				mutation login($email: String!, $password: String!, $projectName: ProjectName!) {
					login(email: $email, password: $password, project: $projectName) {
						ok
						error
						user {
							id
							name
							role
							facebook
							instagram
							twitter
							termsAccepted
							lockedObjects {
								id
							}
						}
					}
				}
			`,
			variables: {
				email,
				password,
				projectName: import.meta.env.VITE_PROJECT_NAME,
			},
		});

		if (response.status === 200) {
			if (json.data) {
				if (json.data.login.ok) {
					$isAuthenticated = true;
					$user = json.data.login.user;
					dispatch('close');
				} else {
					error = json.data.login.error;
				}
			} else {
				error = 'Server Error';
			}
		}
	};

	const forgotPassword = async () => {
		error = '';
		const { response, json } = await api.post({
			query: /* GraphQL */ `
				mutation forgotPassword($email: String!, $projectName: ProjectName!) {
					forgotPassword(email: $email, project: $projectName) {
						ok
						error
					}
				}
			`,
			variables: {
				email,
				projectName: import.meta.env.VITE_PROJECT_NAME,
			},
		});

		if (response.status === 200) {
			if (json.data.forgotPassword.ok) {
				success = json.data.forgotPassword.ok;
			} else {
				error = json.data.forgotPassword.error;
			}
		}
	};
</script>

{#if forgotPasswordFormIsVisible}
	{#if success}
		<div aria-live="polite" class="mx-auto max-w-2xl">
			<div class="text-lg-fluid">E-Mail verschickt</div>
			<p class="mt-8">
				Ein Link zur Wiederherstellung Ihres Passworts wurde an {email} verschickt.
			</p>
			<p class="mt-5">
				Wenn Sie kein E-Mail bekommen haben, kontaktieren Sie uns bitte unter <a
					href="mailto:crowdsourcing@wienbibliothek.at">crowdsourcing@wienbibliothek.at</a
				>.
			</p>
		</div>
	{:else}
		<form on:submit|preventDefault={forgotPassword}>
			<label for="email">E-Mail-Adresse</label>
			<input type="email" id="email" bind:value={email} required autocomplete="email" />
			<div class="mt-4 flex items-center">
				<div class="flex-1">
					<button
						class="text-sm-fluid underline"
						type="button"
						on:click={toggleForgotPasswordForm}>Abbrechen</button
					>
				</div>

				{#if error}
					<div class="flex-1 text-right">
						<p class="text-sm-fluid text-orange" aria-live="assertive">{error}</p>
					</div>
				{/if}
			</div>

			<button type="submit" class="button mt-10 mx-auto">Passwort zurücksetzen</button>
		</form>
	{/if}
{:else}
	<form on:submit|preventDefault={login}>
		<label for="email">E-Mail-Adresse</label>
		<input type="email" id="email" bind:value={email} required autocomplete="email" />
		<label for="password">Passwort</label>
		<input
			type="password"
			id="password"
			bind:value={password}
			required
			autocomplete="current-password"
		/>
		<div class="mt-4 flex">
			<div class="flex-1">
				<button
					class="text-sm-fluid underline"
					type="button"
					on:click={toggleForgotPasswordForm}>Passwort vergessen</button
				>
			</div>

			{#if error}
				<div class="flex-1 text-right mt-[0.3125rem]">
					<p class="text-sm-fluid text-orange" aria-live="assertive">{error}</p>
				</div>
			{/if}
		</div>

		<button type="submit" class="button mt-10 mx-auto">Anmelden</button>
	</form>

	{#if resent}
		<p aria-live="polite">Bitte überprüfen Sie Ihren E-Mail-Posteingang.</p>
	{/if}
{/if}

<style lang="postcss">
	form {
		display: flex;
		flex-direction: column;
		margin-inline: auto;
		max-inline-size: 30rem;
	}

	label {
		@apply text-sm-fluid uppercase;
	}

	input {
		background-color: transparent;
		margin-block-start: 0.25rem;
		padding-block: 0.625rem;
		text-align: center;

		& + label {
			margin-block-start: 1.25rem;
		}
	}
</style>
